export type ColorTheme = 'light' | 'dark';

export const COLOR_THEME_STORAGE_KEY = 'colorTheme';
